<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="addressList">
      <div v-for="item in list" :key="item.id" class="addressRect">
        <div class="name" @click="onSelect(item)">
          {{ item.name }}， {{ item.phoneCountry }} {{ item.tel }}
        </div>
        <div class="address" @click="onSelect(item)">
          {{ item.zipString }}{{ item.address }}
        </div>
        <div class="editButton">
          <i class="iconfont iconbianji" @click="onEdit(item)" />
        </div>
      </div>
    </div>
    <div class="emptyRect" />
    <div class="downButton">
      <van-button type="warning" size="large" :color="GetColorMain()" style="width:100%" @click="onAdd">新增地址</van-button>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
// import {  } from '@/utils/base'
import { Button } from 'vant'
import TopBar from '@/components/TopBar'
import commondata from '@/commondata.js'
import { getUrlKey } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
// import Cookies from 'js-cookie'
export default {
  components: {
    [Button.name]: Button,
    TopBar
  },
  data() {
    return {
      buttonLoading: false,
      title: '地址管理',
      backurl: '/my/index',
      chosenAddressId: '1',
      list: [],
      buttonTitle: '新增地址',
      isManage: false
    }
  },
  created() {
    if (getUrlKey('isManage')) {
      this.isManage = true
    }
    request({
      url: '/StoreHelper/getUserAddressModelList',
      method: 'post'
    }).then(Response => {
      if (Response.success) {
        this.list = Response.data
      }
    })
  },
  methods: {
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,

    onSelect(item) {
      if (this.isManage) {
        return
      }
      commondata.selectAddress = item
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push(this.backUrl)
    },
    onAdd() {
      this.$router.push('/store/addressEdit')
    },
    onEdit(item) {
      this.$router.push('/store/addressEdit?addressId=' + item.id)
    }
  }
}
</script>

<style scoped>
.addressList{
  margin: 1em;
  border-radius: 0.5em;
  background-color: #fff;
}
.addressRect{
  padding: 1em;
  position: relative;
  border-bottom: 1px solid #ebedf0;
}
.addressRect:last-child
{
  border-bottom:none;
}
.addressRect .name{
  font-size: 0.8em;
  padding:0.2em 0;
}
.addressRect .address{
  font-size: 0.8em;
  color:#7d7e80;
  padding:0.2em 0;
}
.addressRect .editButton{
  position: absolute;
  right:1em;
  top:1.7em;
}
.emptyRect{
  height: 3em;
}
.downButton{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
